import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { renderRoutes } from "react-router-config";
import configureStore from "./store/configureStore";
import routes from "./config/routes";
import { ScrollToTop } from "./components";
// import registerServiceWorker from './registerServiceWorker';

const store = configureStore();

class Index extends React.Component {
  render() {
    return (
      <Provider store={store} key="provider">
        <BrowserRouter>
          <ScrollToTop>{renderRoutes(routes)}</ScrollToTop>
        </BrowserRouter>
      </Provider>
    );
  }
}

ReactDOM.render(<Index />, document.getElementById("root"));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js